@if (isOpen) {
<div class="modal-overlay" [class.closing]="isClosing">
  <div class="modal-content" [class.closing]="isClosing">
    <div class="check-icon">
      <img src="./assets/checked.svg" alt="check icon" />
    </div>
    <h2>¡Excelente!</h2>
    <p>{{ message }}</p>
    <button class="button-main" (click)="onContinue()">Continuar</button>
  </div>
</div>
}
